import React, { useContext } from 'react'
import Particles from 'react-particles-js'
import styled from 'styled-components'
import snowLight from '../config/particlesjs-snow-light.json'
import snowDark from '../config/particlesjs-snow-dark.json'
import { MyLogo } from '../components/MyLogo'
import { ThemeContext } from 'styled-components'
import { Github } from '../AllSvg'
import { MyWorkList } from '../data/MyWorkList'

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  -ms-overflow-style: none;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
  }
`

const Container = styled.div`
  z-index: 1;
  position: absolute;
  top: 10%;
  bottom: 5%;
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
  }
`
const WorkBox = styled.div`
  max-width: 300px;
  min-width: 300px;
  background-color: ${props => props.theme.text};
  margin: 0px 15px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 50px;
  display: flex;
  flex-direction: column;
`

const WorkImage = styled.div`
  margin: 45px 15px 0px 15px;
  height: 200px;
  background-image: url(${props => props.bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`
const WorkTitle = styled.h3`
  flex: 1;
  line-height: 35px;
  color: ${props => props.theme.body};
  padding: 20px 15px;
`
const WorkButton = styled.div`
  background-color: ${props => props.theme.body};
  color: ${props => props.theme.text};
  padding: 10px;
  margin: 0px 15px 45px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  p{
    margin: 0px 10px;
  }
`
export const WorkPage = () => {

  const theme = useContext(ThemeContext)
  const background = theme.isLight ? snowLight : snowDark

  return (
    <div>
      <Wrapper>
        <MyLogo/>
        <Particles 
          params={background}
          canvasClassName={`${ theme.isLight ? "particlesLight" : "particlesDark" }`}
        />
        <Container>
        {MyWorkList.map((item,index) => (
          <WorkBox key={index}>
            <WorkImage bg={item.img}/>
            <WorkTitle>{item.title}</WorkTitle>
            <WorkButton>
              <Github fill={theme.text} height={30}/>
              <p>Visit my work</p>
            </WorkButton>
          </WorkBox>
        ))}
        </Container>
      </Wrapper>
    </div>

  )
}
